import { useSnackbar } from "../composables/snackbar";
import { SnackbarMessage } from "../composables/snackbar/interfaces";

export function showSnackbar(o: SnackbarMessage) {
  return useSnackbar().add(o);
}
